import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { SellerStatus } from "../../../objects/amazon/seller";
import { AmazonService } from "../../../services/amazon.service";
import { NavigateHelper } from "../../../common/helpers/navigateHelper";
import { AmazonSignFormComponent } from "../sign/amazon-sign-form-modal.component";


@Component({
    selector: 'amazon-dashboard',
    templateUrl: 'amazon-dashboard.component.html',
    moduleId: module.id.toString(),
})

export class AmazonDashboardComponent implements OnInit{

    public storeProductsRouting: string = null;
    public idToBlur: string = "amazon-dashboard";
    private body: HTMLElement;
    @ViewChild('signModal')
    public signForm: AmazonSignFormComponent;
    @ViewChild('dashboard')
    public dashboard: ElementRef;

    constructor(public router: Router, public amazonService: AmazonService) {
    }

    public ngOnInit() {
        this.storeProductsRouting = NavigateHelper.amazonSellerRouting(this.amazonService.seller);
        const el = document.querySelector("#amazonInfo");

        if (el) {
            el.scrollTop = 0
        }


    }
    public showSignForm(){
        // if(this.amazonService.seller.PoaNumber == SellerStatus.NotStarted || this.amazonService.seller.BnNumberStatus == SellerStatus.NotStarted){
        //     this.signForm.show();
        // }

        this.signForm.show();
    }

    public setButtonClass(sellerStatus: SellerStatus): string {
        switch (sellerStatus) {
            case SellerStatus.Done:
                return 'btn-green-style';
            case SellerStatus.InProgress:
                return 'btn-yellow-style';
            case SellerStatus.NotStarted:
                return 'btn-red-style';
        }
    }

    public userNavigate(routing: string) {
        this.amazonService.setPrevUrl(this.router.url);
        this.router.navigate([routing]);
    }
}


// WEBPACK FOOTER //
// ./app/components/amazon/amazon-dashboard/amazon-dashboard.component.ts